<template>
  <div class="staff-chat-supervise">
    <div class="staff-chat-supervise-search">
      <div class="row-class">
        <div class="col-item">
          <el-select
            v-model="formInline.empRecentTimeStatus"
            placeholder="操作类型"
            size="mini"
            @change="selectBindStatus"
            style="width: 175px; margin-right: 10px "
          >
            <el-option
              v-for="item in operationOptions"
              :key="item.bindStatus"
              :label="item.label"
              :value="item.bindStatus"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-item">
          <el-input
            size="mini"
            v-model="formInline.queryStaffChat"
            placeholder="姓名/部门"
            @blur="onInputBlur"
            @clear="onInputBlur"
            clearable
          >
            <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table
          size="small"
          :data="tableData"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          :height="tableHeight"
          ref="staffChatTable"
          id="diyitable"
          style="font-size: 13px"
        >
          <!-- v-loading="loading"
          element-loading-text="拼命加载中" -->
          <!-- <el-table-column prop="rowNumb" label="NO." width="60px" /> -->
          <el-table-column prop="name" label="员工" />
          <el-table-column prop="departmentName" label="部门" />
          <el-table-column prop="friendNumb" label="好友数" />
          <el-table-column prop="recentStaffTime" label="最近聊天">
            <template slot-scope="scope">
              <span
                style="color: #FFAA33"
                v-if="scope.row.recentStaffTime == null"
                >无最近聊天时间</span
              >
              <span v-else>{{ scope.row.recentStaffTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                icon="el-icon-view"
                :disabled="handleDisable(scope.row)"
                @click.native="viewContent(scope.row)"
                >聊天内容</el-link
              >
              <!-- <el-link  type="primary" :underline="false" icon="el-icon-view" :disabled="handleDisable(scope.row)"
                @click.native="test(scope.$index, scope.row)">聊天内容</el-link> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <!-- <div> -->
    <el-dialog
      :title="chatTitle"
      :visible.sync="dialogVisible"
      class="chat-content-dialog"
      :close-on-click-modal="false"
      :center="true"
      width="956px"
      :close-on-press-escape="true"
      @close="close"
    >
      <div>
        <!-- 新版聊天弹窗 -->
        <ChatContent :idData="uid" v-if="newEditionDialogVisible" />
        <!-- 旧版聊天弹窗 2025.05.29取消旧版,同时因为使用了新企微登录组件进行登录处理,也可以在浏览器查看企业会话存档的聊天记录-->
        <!-- <StaffChatView :idData="uid" v-if="environment === 'other' || !isNewEdition" /> -->
      </div>
    </el-dialog>
    <!-- </div> -->
  </div>
</template>
<script>
import {
  getSessionVersion,
  getChatAuditStaffsInfo,
  getAuthUserList,
} from "@/api/staff/staff.js";
// import StaffChatView from "../chat/components/StaffChatView.vue";
import ChatContent from "../chat/components/newChat/ChatContent.vue";

export default {
  name: "StaffChatSupervise",
  components: {
    // StaffChatView,
    ChatContent,
  },

  data() {
    return {
      tableData: [],
      operationOptions: [
        {
          bindStatus: 0,
          label: "全部",
        },
        {
          bindStatus: 1,
          label: "存在聊天记录的员工",
        },
      ],
      tableHeight: 50,
      dialogVisible: false,
      uid: "",
      chatTitle: "",
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },
      formInline: {
        currentPage: 1,
        pageSize: 20,
        empRecentTimeStatus: 1,
        department: "",
        queryStaffChat: "",
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      list: JSON.parse(localStorage.getItem("routerList")),
      flatList: [],
      ISH: false,
      ISO: false,
      myDepartment: JSON.parse(localStorage.getItem("myDepartment")),
      /** 是否新版本会话 true新版 false 旧版 2025.05.29取消旧版*/
      // isNewEdition: true,
      /** 控制聊天内容弹窗显示隐藏 */
      newEditionDialogVisible: false,
      /** 当前所属环境 com-wx-mobile手机端企业微 com-wx-pc电脑端企微 other其他环境（外部浏览器）*/
      // environment: "",
      // 提示实例，防止弹出多个提示
      messageInstance: null,
      /** 接口是否请求完毕 */
      isRequestSuccess: true,
      /** 弹窗的加载实例 */
      // dialogLoadingInstance: null,
    };
  },

  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "聊天审计-员工列表") {
              console.log("XXXXXXXX", item);
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("ltjlckbbm") != -1) {
                // 可新增、编辑、删除分组
                this.ISH = true;
              } else {
                this.ISH = false;
              }
              if (senBtnAuthority.indexOf("ltjlckkbm") != -1) {
                // 可新增、删除敏感词
                this.ISO = true;
              } else {
                this.ISO = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    handleDisable(data) {
      console.log("查看记录权限", data);
    },
    handleLimits() {
      this.handleFlat(this.$store.state.tagsView.routerList);
      this.flatList.forEach((item) => {
        if (item.menuId == "85") {
          this.ISH = true;
        }
        if (item.menuId == "86") {
          this.ISO = true;
        }
      });
    },
    // 扁平化数组
    handleFlat(list) {
      list.forEach((item) => {
        if (item.menus.length <= 0) {
          this.flatList.push({ menuName: item.menuName, menuId: item.menuId });
        } else {
          this.handleFlat(item.menus);
        }
      });
    },
    selectTime() {
      this.getChatAuditStaffsInfoData(this.formInline);
    },
    onInputBlur() {
      this.formInline.currentPage = 1;
      this.getChatAuditStaffsInfoData(this.formInline);
    },
    selectBindStatus(value) {
      this.formInline.empRecentTimeStatus = value;
      this.formInline.currentPage = 1;
      this.getChatAuditStaffsInfoData(this.formInline);
    },

    // 获取员工列表（新、旧版）
    getChatAuditStaffsInfoData(parameter) {
      // 2025.05.29取消旧版,同时因为使用了新企微登录组件进行登录处理,也可以在浏览器查看企业会话存档的聊天记录
      // 当是新版并在企微内部启动时，调用新版（目前登录使用的是链接的形式，无法在浏览器查看会话组件，需后续换登录方式 2024.06.19）
      // if (this.isNewEdition && this.environment !== 'other') {
      //   console.log("新版");
      /** 新版走这里 */
      getAuthUserList(parameter, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res && res.error && res.error.code == 200) {
            this.tableData = res.data.result;
            this.pageparm.total = res.data.totals;
            this.pageparm.currentPage = this.formInline.currentPage;
            this.pageparm.pageSize = this.formInline.pageSize;
          } else {
            if (this.messageInstance) this.messageInstance.close();
            this.messageInstance = this.$message.error("获取失败，请稍后再试");
          }
        })
        .catch((err) => {
          if (this.messageInstance) this.messageInstance.close();
          this.messageInstance = this.$message.error("获取失败，请稍后再试");
          console.log("获取新版员工失败", err);
        });
      // } else {
      //     console.log("旧版");
      //   /** 旧版 */
      //   getChatAuditStaffsInfo(
      //     parameter,
      //     localStorage.getItem("Authorization")
      //   ).then((res) => {
      //     if (res.error.code == 200) {
      //       this.tableData = res.data.result;
      //       this.pageparm.total = res.data.totals;
      //       this.pageparm.currentPage = this.formInline.currentPage;
      //       this.pageparm.pageSize = this.formInline.pageSize;
      //     }
      //   });
      // }
    },

    search() {
      this.loading = true;
      this.formInline.currentPage = 1;
      this.getChatAuditStaffsInfoData(this.formInline);
    },
    test(index, row) {
      // this.handleLimits();
      let departmentId = row.departId.split(",")[1];
      if (this.ISH && this.myDepartment == departmentId) {
        this.uid = row.userId;
        this.dialogVisible = true;
        this.chatTitle = row.name + "的聊天内容";
      } else if (this.ISO && this.myDepartment != departmentId) {
        this.uid = row.userId;
        this.dialogVisible = true;
        this.chatTitle = row.name + "的聊天内容";
      } else if (this.ISO && this.ISH) {
        this.uid = row.userId;
        this.dialogVisible = true;
        this.chatTitle = row.name + "的聊天内容";
      } else {
        this.$message.warning("暂无权限查看聊天记录");
      }
      console.log("---------------", row.departId.split(",")[1]);
      // this.uid = row.userId;
      // this.dialogVisible = true;
      // this.chatTitle = row.name + "的聊天内容";
    },
    controlHeight() {
      this.$nextTick(function() {
        this.tableHeight =
          window.innerHeight - this.$refs.staffChatTable.$el.offsetTop - 237;

        // 监听窗口大小变化
        let self = this;
        window.onresize = function() {
          self.tableHeight =
            window.innerHeight - self.$refs.staffChatTable.$el.offsetTop - 237;
        };
      });
    },
    callBack(parm) {
      this.formInline.currentPage = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      // this.loading = true;
      this.getChatAuditStaffsInfoData(this.formInline);
    },

    // 新版查看聊天内容
    viewContent(row) {
      let departmentId = row.departId.split(",")[1];
      if (this.ISH && this.myDepartment == departmentId) {
        this.uid = row.userId;
        this.dialogVisible = true;
        this.newEditionDialogVisible = true;
        this.chatTitle = row.name + "的聊天内容";
      } else if (this.ISO && this.myDepartment != departmentId) {
        this.uid = row.userId;
        this.dialogVisible = true;
        this.newEditionDialogVisible = true;
        this.chatTitle = row.name + "的聊天内容";
      } else if (this.ISO && this.ISH) {
        this.uid = row.userId;
        this.dialogVisible = true;
        this.newEditionDialogVisible = true;
        this.chatTitle = row.name + "的聊天内容";
      } else {
        this.$message.warning("暂无权限查看聊天记录");
      }
    },

    /** 弹窗关闭 */
    close() {
      console.log("弹窗关闭");
      this.dialogVisible = false;
      // 把新版聊天组件弹窗销毁
      this.newEditionDialogVisible = false;
    },

    /** 获取判断新旧版本参数（参数由总控控制，必须最先执行完在执行获取列表数据） */
    // async getVersionsParams() {
    //   await getSessionVersion(localStorage.getItem("Authorization")).then((res) => {
    //     if (res && res.error && res.error.code === 200) {
    //       this.isNewEdition = res.data
    //       window.localStorage.setItem("isNewEdition", this.isNewEdition);
    //     } else {
    //       this.$message.error("获取版本参数失败")
    //     }
    //   }).catch((err) => {
    //     this.$message.error("获取版本参数失败")
    //     console.log("新旧版本参数获取失败", err);
    //   });
    // },

    /** 获取当前环境 */
    // getEnvironment() {
    //   let isMobile = window.navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   ); // 是否手机端
    //   let isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
    //   if (isComWx && isMobile) {
    //     //手机端企业微信
    //     this.environment = "com-wx-mobile";
    //   } else if (isComWx && !isMobile) {
    //     //PC端企业微信
    //     this.environment = "com-wx-pc";
    //   } else {
    //     //其他环境
    //     this.environment = "other";
    //   }
    //   window.localStorage.setItem("environment", this.environment);
    // },

    // requestSuccess(val) {
    //   console.log("val123+++++", val);
    //   if (!val) {
    //      this.dialogLoadingInstance ? this.dialogLoadingInstance.close() : ''
    //   }else{
    //     this.dialogLoadingInstance = this.$loading({
    //       target: '.el-dialog',
    //       text: '拼命加载中...',
    //     })
    //   }
    // }
  },

  async created() {
    /** 获取当前环境 */
    // this.environment = window.localStorage.getItem("environment") || await this.getEnvironment()
    /** 获取判断新旧版本参数 */
    // await this.getVersionsParams()
    /** 获取员工数据 */
    this.getChatAuditStaffsInfoData(this.formInline);
  },

  updated() {
    this.$nextTick(() => {
      this.$refs["staffChatTable"].doLayout();
    });
  },

  mounted() {
    this.controlHeight();
  },
};
</script>
<style lang="scss" scoped>
.staff-chat-supervise {
  .staff-chat-supervise-search {
    margin-bottom: 10px;

    .row-class {
      display: flex;
      // justify-content: flex-end;
      padding-bottom: 5px;
    }
  }

  .el-dialog {
    z-index: 100 !important;
    min-width: 1000px;
    width: 70%;

    .el-dialog__title {
      line-height: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #0f0f0f;
    }

    .el-dialog__body {
    }
  }
}
</style>
